import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StockComponent } from './stock-list/stock-list.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { StockFormComponent } from './stock-form/stock-form.component';
import { StockDetailComponent } from './stock-detail/stock-detail.component';

  // o Administrador Khuzela faz CRUD do Produto
  // o Utilizador Khuzela  só Lê e Actualiza do produto
  // o Manager do Clube faz CRUD
  // o Utilizador do Clube lê e actualiza

const routes:Routes=[
    {path:'',redirectTo:'list',pathMatch:'full'},
    {path:'list',component:StockComponent,canActivate:[RoleGuard],data:{roles: ["user",'userClube', "admin",'manager']}},
    {path:'new',component:StockFormComponent,canActivate:[RoleGuard],data:{roles: ["admin",'manager']}},
    {path:'edit',component:StockFormComponent,canActivate:[RoleGuard],data:{roles: ["admin",'manager',"user",'userClube']}},
    {path:'detail',component:StockDetailComponent,canActivate:[RoleGuard],data:{roles: ["admin",'manager',"user",'userClube']}}
]

@NgModule({
    imports: [
      RouterModule.forChild(routes)
    ],
    exports:[
      RouterModule
    ]
  })
  export class StockRoutingModule { }
  